'use client'
export function SilentErrorFallback() {
  return (
    <>
    </>
  )
}
